import { AmbassadorMini } from '@omniafishing/core';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isUserPublic, NAME_FALLBACK } from '../../lib/user';
import { RoutePaths } from '../../routes';
import { SpanLink } from '../span_link/span_link';
import { UserProfileImgRinged } from '../user_profile_img_ringed/user_profile_img_ringed';
import styles from './org_detail.less';

export const MemberList = (props: { members: AmbassadorMini[] }) => {
  const { members } = props;
  const [showUsers, setShowUsers] = useState(false);
  const member_count = members.length;

  if (member_count === 0) {
    return null;
  }

  return (
    <>
      <p>
        <SpanLink
          onClick={() => {
            setShowUsers(!showUsers);
          }}
        >
          {member_count} member{member_count > 1 && 's'}
        </SpanLink>
      </p>
      {showUsers && (
        <div>
          <ul className={styles.users}>
            {members.map((u) => {
              const userFullName = u.full_name || NAME_FALLBACK;
              const userContent =
                u.slug && isUserPublic(u) ? (
                  <Link to={`${RoutePaths.USERS}/${u.slug}`}>{userFullName}</Link>
                ) : (
                  userFullName
                );
              return (
                <li key={u.id}>
                  <div className={styles.user}>
                    <UserProfileImgRinged
                      role={u.role}
                      image={u.image}
                      imageSize={60}
                      size={40}
                      borderSize={0}
                      style={{ flex: '0 0 auto' }}
                    />
                    <p className={styles.userName}>{userContent}</p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};
